export const LOGIN_PATH = `/_hcms/mem/login`;
export const SUPPORT_PORTAL_EXPORT_BASE_PATH = `/_hcms/support-portal-export`;
export const TICKET_EXPORT_CSV_PATH = `/v1/ticket/csv`;
export const FILE_MANAGER_BASE_PATH = `/_hcms/customerportal/filemanager`;